// extracted by mini-css-extract-plugin
export default {"termsAndConditions":"StoryDetails_termsAndConditions__jLyGn","bottomPadding":"StoryDetails_bottomPadding__gnrIx"};